import { observable, action, computed, configure, runInAction } from "mobx";
import { createContext } from "react";
import { IFttbHour } from "../models/fttbhour";
import { ITechnician } from "../models/technician";
import { toast } from "react-toastify";
import agent from "../api/agent";
import { isNumeric } from "revalidate";
import { IPayrollCycle } from "../models/payrollcycle";

configure({ enforceActions: "always" });

class EmployeeFttbHourStore {
  @observable employeefttbhourRegistry = new Map();
  @observable employeefttbhour: IFttbHour | null = null;
  @observable payrollcycleRegistry = new Map();
  @observable loadingInitial = false;
  @observable submitting = false;
  @observable target = "";

  @computed get employeefttbhournamesByDate() {
    return Array.from(this.employeefttbhourRegistry.values()).sort(
      (a, b) => Date.parse(a.date) - Date.parse(b.date)
    );
  }

  @computed get payrollcyclesByName() {
    return Array.from(this.payrollcycleRegistry.values()).sort(
      (a, b) =>
        a.startYear.localeCompare(b.startYear) ||
        a.endYear.localeCompare(b.endYear) ||
        a.payRun.localeCompare(b.payRun)
    );
  }

  @action searchEmployeeFttbHours = async (search: {
    tech: string;
    payRun: string;
    jobStartDate: string;
    jobEndDate: string;
    orderNo: string;
  }) => {
    if (
      search.tech === "" &&
      search.payRun === "" &&
      search.jobStartDate === "" &&
      search.jobEndDate === "" &&
      search.orderNo === ""
    ) {
      toast.info("Please select at least one search condition");
      return;
    } else if (search.jobStartDate !== "" && search.jobEndDate === "") {
      toast.info("Please select job end date");
      return;
    } else if (search.jobEndDate !== "" && search.jobStartDate === "") {
      toast.info("Please select job start date");
      return;
    }
    const params = new URLSearchParams();
    params.append("tech", search.tech);
    params.append("payRun", search.payRun);
    params.append("jobStartDate", search.jobStartDate);
    params.append("jobEndDate", search.jobEndDate);
    params.append("orderNo", search.orderNo);

    this.loadingInitial = true;
    try {
      const fttbhours = await agent.FttbHours.search(params);
      this.employeefttbhourRegistry.clear();
      runInAction("loading fttbhours", () => {
        fttbhours.forEach((employeefttbhour) => {
          if (employeefttbhour.date !== null)
            employeefttbhour.date = employeefttbhour.date.substr(0, 10);
          this.employeefttbhourRegistry.set(
            employeefttbhour.id,
            employeefttbhour
          );
        });
        this.loadingInitial = false;
      });
    } catch (error) {
      runInAction("load FttbHour List error", () => {
        this.loadingInitial = false;
      });
      toast.error("load FttbHour List error");
    }
  };

  @action loadFttbHour = async (id: string) => {
    let employeefttbhour = this.getFttbHour(id);
    if (employeefttbhour) {
      this.employeefttbhour = employeefttbhour;
      return employeefttbhour;
    } else {
      this.loadingInitial = true;
      try {
        const employeefttbhour = await agent.FttbHours.details(id);
        runInAction("getting employeefttbhour", () => {
          // this.employeefttbhourRegistry.clear();
          this.employeefttbhour = employeefttbhour;
          // if (employeefttbhour.date !== null)  employeefttbhour.date = employeefttbhour.date.substr(0,10);
          // this.employeefttbhourRegistry.set(employeefttbhour.id, employeefttbhour);
          this.loadingInitial = false;
        });
        return employeefttbhour;
      } catch (error) {
        runInAction("get employeefttbhour error", () => {
          this.loadingInitial = false;
        });
        toast.error("get employeefttbhour error");
        console.log(error);
      }
    }
  };

  @action clearFttbHour = () => {
    this.employeefttbhour = null;
  };

  getFttbHour = (id: string) => {
    return this.employeefttbhourRegistry.get(Number(id));
  };

  // @action createFttbHour = async (employeefttbhour: IFttbHour) => {
  //   this.submitting = true;
  //   try {
  //     employeefttbhour.createdAt = new Date().toJSON();
  //     employeefttbhour.updatedAt = new Date().toJSON();
  //     const fttbhourname = await agent.FttbHours.create(employeefttbhour);
  //     runInAction('create Techncian', () => {
  //       this.fttbhournameRegistry.clear();
  //         this.fttbhourname = fttbhourname;
  //         if (fttbhourname.expiryDate !== null)  fttbhourname.expiryDate = fttbhourname.expiryDate.substr(0,10);
  //         this.fttbhournameRegistry.set(fttbhourname.id, fttbhourname);
  //       this.submitting = false;
  //     })
  //   } catch (error) {
  //     runInAction('create FttbHour error', () => {
  //       this.submitting = false;
  //     })
  //     toast.error('create FttbHour error');
  //     console.log(error);
  //   }
  // };

  @action loadPayrollCycles = async () => {
    this.loadingInitial = true;
    try {
      const payrollcycles = await agent.PayrollCycles.list();
      runInAction("loading payroll cycles", () => {
        payrollcycles.forEach((payrollcycle) => {
          this.payrollcycleRegistry.set(
            payrollcycle.startYear +
              "-" +
              payrollcycle.endYear +
              "-" +
              payrollcycle.payRun,
            payrollcycle
          );
        });
        this.loadingInitial = false;
      });
    } catch (error) {
      runInAction("load payroll cycles error", () => {
        this.loadingInitial = false;
      });
      toast.error("load payroll cycles error");
    }
  };
}

export default createContext(new EmployeeFttbHourStore());
